import { ValidationService } from './validationService';
import { ValidationRegistry } from './validationRegistry';
import { ValidationServiceProvider } from './validationServiceProvider';
ValidationServiceProvider.setInstance(new ValidationService(() => new ValidationRegistry()));
export { ValidationServiceProvider };
//# sourceMappingURL=validationServiceSetup.js.map